import axios from "axios"

import { Medium } from "@/models/medium.js"
import { Lesson } from "@/models/lesson.js"

export const getLessonMedium = async ({ mediumId }) => {
  const response = await axios.get(`/api/v2/lesson_media/${mediumId}`)

  return { ...response, medium: new Medium(response.medium) }
}

export const getLesson = async ({ courseId, lessonId }) => {
  const response = await axios.get(`/api/v2/courses/${courseId}/lessons/${lessonId}`)

  return { ...response, lesson: new Lesson(response.lesson) }
}

export const getLessons = async ({ courseId, page } = {}) => {
  const response = await axios.get(`/api/v2/courses/${courseId}/lessons`, {
    params: {
      page: page
    }
  })

  return { ...response, lessons: response.lessons.map((l) => new Lesson(l)) }
}

export const markAsCompleted = ({ courseId, lessonId }) => axios.post(`/api/v2/courses/${courseId}/lessons/${lessonId}/complete`)

export const markAsUncompleted = ({ courseId, lessonId }) => axios.post(`/api/v2/courses/${courseId}/lessons/${lessonId}/uncomplete`)
